import api from "../../http";

export default class ApiContactsText {
  static async getApiContactsText(url) {
    return api.get(url)
  }
}